import PropTypes from 'prop-types';
import cn from 'classnames';

const Button = ({
  type,
  children,
  isLoading,
  disabled,
  onClick,
  variation,
  className,
  testId,
  ...rest
}) => (
  <button
    type={type}
    disabled={disabled || isLoading}
    onClick={onClick}
    className={cn(`btn btn-${variation}`, {
      loading: isLoading,
      [className]: className,
    })}
    data-testid={testId}
    {...rest}
  >
    {isLoading && 'Loading...'}
    <span>{children}</span>
  </button>
);

Button.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  variation: PropTypes.oneOf(['primary', 'secondary', 'link', 'reset']),
  className: PropTypes.string,
  testId: PropTypes.string,
};

Button.defaultProps = {
  type: 'button',
  disabled: false,
  isLoading: false,
  onClick: () => {},
  variation: 'primary',
  className: '',
  testId: 'button',
};

export default Button;
